module.exports = __webpack_public_path__ + "static/media/grslogo.7849ec7c.png";